export const baseUrl = process.env.REACT_APP_API_BASE_URL;

export const apiUrl = baseUrl + "/api";
export const outerPages = ["/", "/login", "/workspaces", "/logout/callback", "/workspaces/", "/permission-denied", "/no-content/", "/token/", "/forgot-password", "/forgot-password/", "/logout", "/forgot-password"];
